import { CloseOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Form, Input, Select } from 'antd';
import classNames from 'classnames';
import { useRef } from 'react';
import { QUESTION_TYPE } from './Question';
import { textOnly } from '../../util/util';

export default function Multiple({ form, item, part, type }) {
    const inputRef = useRef(null);

    const isOther = (index) => {
        // Check index in item answerValue.optionName is 'Other'
        return item.answerValue[index]?.optionName === 'Other';
    };

    const isHasOther = item.answerValue.some(
        (item) => item.optionName === 'Other'
    );

    return (
        <Form.List name={form.name}>
            {(fields, { add, remove }) => (
                <div className="grid grid-cols-1 gap-4">
                    {fields.map(({ key, name, ...restField }, index) => (
                        <div key={key} className="grid grid-cols-2 gap-4">
                            <div
                                className={classNames(
                                    'flex items-center gap-2',
                                    {
                                        'col-span-2': !item.isSkip,
                                    }
                                )}
                            >
                                <div
                                    className={classNames(
                                        'w-4 h-4 border border-[#65707A] flex-shrink-0',
                                        {
                                            'rounded-sm':
                                                type === QUESTION_TYPE.CHECKBOX,
                                            'rounded-full':
                                                type === QUESTION_TYPE.RADIO,
                                        }
                                    )}
                                ></div>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'optionName']}
                                    className="mb-0 w-full"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                'ตัวเลือกไม่สามารถเว้นว่างได้',
                                        },
                                        {
                                            validator: async (_, value) => {
                                                // check if value can't duplicate
                                                const isDuplicate =
                                                    item?.answerValue
                                                        ?.map((item) =>
                                                            item.optionName?.trim()
                                                        )
                                                        .filter(
                                                            (item, i) =>
                                                                item &&
                                                                fields[i]
                                                                    .key !== key
                                                        )
                                                        .includes(
                                                            value?.trim()
                                                        );
                                                if (isDuplicate) {
                                                    return Promise.reject(
                                                        'ตัวเลือกไม่สามารถซ้ำกันได้'
                                                    );
                                                }
                                            },
                                        },
                                    ]}
                                >
                                    {isOther(index) ? (
                                        <div className="font-semibold ml-3">
                                            อื่นๆ (โปรดระบุ)
                                        </div>
                                    ) : (
                                        <Input
                                            size="large"
                                            ref={
                                                fields.length - 1 === index &&
                                                inputRef
                                            }
                                            className="bg-transparent w-full"
                                        />
                                    )}
                                </Form.Item>

                                <button
                                    hidden={fields.length === 1}
                                    onClick={() => remove(name)}
                                    type="button"
                                >
                                    <CloseOutlined className="text-xl text-purple-PHX" />
                                </button>
                            </div>
                            {item.isSkip && (
                                <Form.Item
                                    {...restField}
                                    name={[name, 'skipToPart']}
                                    noStyle
                                    initialValue={null}
                                >
                                    <Select size="large" className="w-full">
                                        {part.map((item, index) => {
                                            const _textOnly = (name) =>
                                                name
                                                    ? textOnly(name)
                                                    : 'ส่วนไม่มีชื่อ';
                                            if (index === 0)
                                                return (
                                                    <Select.Option
                                                        key={index}
                                                        value={null}
                                                    >
                                                        ไปยังส่วนถัดไป
                                                    </Select.Option>
                                                );
                                            else
                                                return (
                                                    <Select.Option
                                                        key={index}
                                                        value={index + 1}
                                                    >{`ไปที่ส่วน ${
                                                        index + 1
                                                    } (${_textOnly(
                                                        item.partName
                                                    )})`}</Select.Option>
                                                );
                                        })}
                                    </Select>
                                </Form.Item>
                            )}
                        </div>
                    ))}
                    <Form.Item className="mb-0">
                        <div className="flex items-center">
                            <button
                                type="button"
                                className="text-[#1890FF] flex items-center gap-1 w-max"
                                onClick={() => {
                                    // When have 'Other' option, add before 'Other' option
                                    const ohterIndex =
                                        item.answerValue.findIndex(
                                            (item) =>
                                                item.optionName === 'Other'
                                        );

                                    if (ohterIndex !== -1) {
                                        add(
                                            {
                                                optionName: `ตัวเลือก ${
                                                    fields.length + 1
                                                }`,
                                            },
                                            ohterIndex
                                        );
                                    } else {
                                        add({
                                            optionName: `ตัวเลือก ${
                                                fields.length + 1
                                            }`,
                                        });
                                    }

                                    setTimeout(() => {
                                        inputRef?.current?.focus({
                                            cursor: 'all',
                                        });
                                    }, 100);
                                }}
                            >
                                <PlusCircleOutlined />
                                <span>เพิ่มตัวเลือก</span>
                            </button>
                            {!isHasOther && (
                                <>
                                    <span>หรือ</span>
                                    <button
                                        type="button"
                                        className="text-[#1890FF]"
                                        onClick={() =>
                                            add({
                                                optionName: 'Other',
                                            })
                                        }
                                    >
                                        เพิ่ม “อื่นๆ โปรดระบุ”
                                    </button>
                                </>
                            )}
                        </div>
                    </Form.Item>
                </div>
            )}
        </Form.List>
    );
}
